import { IdFilterType, ID } from '../../../../../types';
import { FetchUsersFilters } from '../../../../../main/users/usersTypes';

export const enum UniversalFilterUsersExtendedModes {
  CONTAINS_ANY_OF = 'contains_any_of',
  // CONTAINS_ALL_OF = 'contains_all_of',
  // CONTAINS_ONLY = 'contains_only',
  // CONTAINS_NONE_OF = 'contains_none_of',
  DOES_NOT_CONTAIN_ANY_OF = 'does_not_contain_any_of'
  // IS_EMPTY = 'is_empty',
  // IS_NOT_EMPTY = 'is_not_empty'
}

export type UniversalFilterUsersExtendedValue = IdFilterType;

export type UniversalFilterUsersExtendedFilterState = {
  mode: UniversalFilterUsersExtendedModes;
  userIds?: ID[];
};

export type UniversalFilterUsersExtendedFilterOptions = {
  initialUsersFilters?: FetchUsersFilters;
  withoutRecentUsers?: boolean;
};

export type UniversalFilterUsersExtendedOnFilterStateChange = (
  state: UniversalFilterUsersExtendedFilterState
) => void;

export type UniversalFilterUsersExtendedOnChange = (
  value?: UniversalFilterUsersExtendedValue
) => void;
